import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 26 25",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "#111224",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m1.898 3.363c-.735 0-1.307.58-1.307 1.327s.572 1.328 1.307 1.328h20.261v-2.655z" }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m0 23.104c0 .893.725 1.612 1.625 1.612h22.75c.9 0 1.625-.719 1.625-1.612v-2.902h-10.075a1.63 1.63 0 0 1 -1.625-1.613v-5.16a1.63 1.63 0 0 1 1.625-1.612h10.075v-2.902c0-.894-.725-1.613-1.625-1.613l-22.73-.02a2.604 2.604 0 0 1 -1.645-.856zm15.925-9.997a.31.31 0 0 0 -.325.322v5.16c0 .19.134.323.325.323h10.075v-5.805z",
    "fill-rule": "nonzero"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m18.206.732.024 5.867h-13.43l-.007-5.883 13.412.016z",
    stroke: "#fff",
    "stroke-width": "1.073"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }